import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {imageService} from '../services/image.service';

const style = {
  position: 'absolute',
  top: '20%',
  left: '50%',
//   transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function FilePreviewModal(props) {



  return (
    <div>
       <a href={imageService.PAYMENT_RECEIVE_ATTACHMENT_URL + props.file} download>
                    <span className='text-primary' >Download File</span>
                 </a>
      
    </div>
  );
}
